export const blockIconsAudioandvideoVideoCallNew = (
	<span className='material-symbols-outlined'>video_call</span>
);
